/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';

import { UserPreferencesTypes, UserPreferencesState } from './types';

const INITIAL_STATE: UserPreferencesState = {
  userPreferences: [],
  request: {
    get_user_preferences: {
      loading: false,
      loaded: false,
      error: false,
    },
    save_user_preferences: {
      loading: false,
      loaded: false,
      error: false,
    },
    delete_user_preferences: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
};

const reducer: Reducer<UserPreferencesState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case UserPreferencesTypes.GET_USER_PREFERENCES_REQUEST:
        draft.request.get_user_preferences = {
          ...INITIAL_STATE.request.get_user_preferences,
          loading: true,
        };
        break;
      case UserPreferencesTypes.GET_USER_PREFERENCES_SUCCESS:
        if (!result) return;

        draft.userPreferences = result.data;
        draft.request.get_user_preferences = {
          ...INITIAL_STATE.request.get_user_preferences,
          loaded: true,
        };
        break;
      case UserPreferencesTypes.GET_USER_PREFERENCES_FAILURE:
        draft.request.get_user_preferences = {
          ...INITIAL_STATE.request.get_user_preferences,
          error: true,
        };
        break;
      case UserPreferencesTypes.SAVE_USER_PREFERENCES_REQUEST:
        draft.request.save_user_preferences = {
          ...INITIAL_STATE.request.save_user_preferences,
          loading: true,
        };
        break;
      case UserPreferencesTypes.SAVE_USER_PREFERENCES_SUCCESS:
        draft.userPreferences = result.data;
        draft.request.save_user_preferences = {
          ...INITIAL_STATE.request.save_user_preferences,
          loaded: true,
        };
        break;
      case UserPreferencesTypes.SAVE_USER_PREFERENCES_FAILURE:
        draft.request.save_user_preferences = {
          ...INITIAL_STATE.request.save_user_preferences,
          error: true,
        };
        break;
      case UserPreferencesTypes.DELETE_USER_PREFERENCES_REQUEST:
        draft.request.delete_user_preferences = {
          ...INITIAL_STATE.request.delete_user_preferences,
          loading: true,
        };
        break;
      case UserPreferencesTypes.DELETE_USER_PREFERENCES_SUCCESS:
        draft.userPreferences = result.data;
        draft.request.delete_user_preferences = {
          ...INITIAL_STATE.request.delete_user_preferences,
          loaded: true,
        };
        break;
      case UserPreferencesTypes.DELETE_USER_PREFERENCES_FAILURE:
        draft.request.delete_user_preferences = {
          ...INITIAL_STATE.request.delete_user_preferences,
          error: true,
        };
        break;

      default:
    }
  });
};

export default reducer;
